import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "../../firebase-config";
import router from '../router';
const messaging = getMessaging(app);

export const generateDeviceToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: "BL8Y-HGxE1hj4VTKcRSDZjXfBhiMmqkXrN_9RME-ck1bM37N8grWycXNe-A7sOMuB34_kpY9jLOCVoRzSQ9XRk0"
    });

    if (token) {
      // console.log("FCM Token:", token);
      return token;
    } else {
      console.log("No registration token available.");
      return null;
    }
  } catch (error) {
    console.error("Token error:", error);
    return null;
  }
};


let isListening = false;

export const listenForegroundMessages = () => {
  if (isListening) return;
  isListening = true;

  onMessage(messaging, (payload) => {
    console.log("Message received:", payload);

    const notificationTitle = payload.data?.title;
    const notificationOptions = {
      body: payload.data?.body,
      icon: "/favicon.png",
      data: payload.data // attach full data to notification
    };

    if (Notification.permission === "granted") {
      const notification = new Notification(notificationTitle, notificationOptions);

      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();

        const type = payload.data?.type;
        console.log("Notification clicked with type:", type, "and data:", payload.data);

    
        switch (type) {
          
          case "eod":
            router.push(`/eod/details/${notification.data.payload}`);
            break;

          case "requisition":
            router.push(`/my-workspace/requisition-details/${notification.data.payload}`);
            break;

          case "leave":
            router.push(`/my-workspace/leave-details/${notification.data.payload}`);
            break;
          
          case "ticket":
            router.push(`/ticket/ticket-details/${notification.data.payload}`);
            break;

          case "budget":
            router.push(`/my-workspace/budget-details/${notification.data.payload}`);
            break;

          case "grievance":
            router.push(`/my-workspace/grievance-details/${notification.data.payload}`);
            break;

          default:
            router.push("/my-workspace/my-updates");
        }

        notification.close();
      };
    }
  });
};

// export const listenForegroundMessages = () => {
//   if (isListening) return;
//   isListening = true;

//   onMessage(messaging, (payload) => {
//     console.log("Message received:", payload);

//     const notificationTitle = payload.notification?.title;
//     const notificationOptions = {
//       body: payload.notification?.body,
//       icon: "/favicon.png"
//     };

//     if (Notification.permission === "granted") {
//       new Notification(notificationTitle, notificationOptions);
//     }
//   });
// };
